import { Action } from '../../../redux/redux.types';
import { MaybeUndef } from '../../../types/system';
import { FLOWS_LIST_ACTION_NAMES } from './flows-list.actions';
import { FLOWS_UI_ACTION_NAMES } from './flows-ui.actions';

export enum FlowsListFilter {
  None,
  Active,
  Inactive,
}

export interface FlowsUiState {
  flowsListFilter: FlowsListFilter;
  selectedFlowId: MaybeUndef<string>;
  selectedFlowVersionId: MaybeUndef<number>;
  isVersionDetailsOpened: boolean;
  isAddingNew: boolean;
}

const defaultState: FlowsUiState = {
  flowsListFilter: FlowsListFilter.None,
  selectedFlowId: undefined,
  selectedFlowVersionId: undefined,
  isVersionDetailsOpened: false,
  isAddingNew: false,
};

export const flowsUi = (
  state: FlowsUiState = defaultState,
  { type, payload }: Action,
): FlowsUiState => {
  switch (type) {
    case FLOWS_UI_ACTION_NAMES.SET_FLOWS_FILTER:
      return {
        ...state,
        selectedFlowId: undefined,
        selectedFlowVersionId: undefined,
        isVersionDetailsOpened: false,
        flowsListFilter: payload,
      };

    case FLOWS_UI_ACTION_NAMES.SELECT_FLOW:
      return {
        ...state,
        isAddingNew: false,
        selectedFlowVersionId: undefined,
        isVersionDetailsOpened: false,
        selectedFlowId: payload,
      };

    case FLOWS_UI_ACTION_NAMES.HIDE_VERSION_DETAILS:
      return {
        ...state,
        isVersionDetailsOpened: false,
      };

    case FLOWS_UI_ACTION_NAMES.SELECT_FLOW_VERSION:
      return {
        ...state,
        selectedFlowVersionId: payload,
        isVersionDetailsOpened: true,
      };

    case FLOWS_UI_ACTION_NAMES.START_NEW_FLOW:
      return {
        ...state,
        isAddingNew: true,
      };

    case FLOWS_UI_ACTION_NAMES.CANCEL_NEW_FLOW:
      return {
        ...state,
        isAddingNew: false,
      };

    case FLOWS_LIST_ACTION_NAMES.CREATE_SUCCESS:
      return {
        ...state,
        selectedFlowVersionId: undefined,
        isVersionDetailsOpened: false,
        isAddingNew: false,
      };

    case FLOWS_UI_ACTION_NAMES.SELECT_FLOW_AND_VERSION: {
      const { flowId, versionRevision } = payload;

      return {
        ...state,
        selectedFlowId: flowId,
        selectedFlowVersionId: versionRevision,
        isVersionDetailsOpened: true,
        isAddingNew: false,
      };
    }

    default:
      return state;
  }
};
